export const ru = {
    error_title: 'К сожалению, произошла ошибка',
    error_description: 'Мы уже в курсе проблемы и скоро всё поправим',
    already_registered_error_title: 'Данная компания уже зарегистрирована',
    solution_step_first: 'Если вы сотрудник данной компании, свяжитесь с тревел-координатором компании, чтобы получить доступ',
    solution_step_second: 'Если это ваша компания и вы не регистрировались обратитесь в поддержку',
    find_company_title: 'Мы нашли вас в 360',
    find_company_description: 'Пожалуйста, введите ИНН вашей компании и мы автоматически загрузим юридическую информацию. Она нужна для оформления билетов и подготовки документов',
};
